<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body fontbody">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Contact list</h5>
                  </div>
                  <small class="text-truncate text-muted">Total 658 (last update 1 month ago)</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="nav-link text-muted" href="javascript:void(0)">Add</a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">List view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Grid view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Add new</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>

              <ul class="nav nav-tabs tab-custom tab-sm d-inline-flex border-0" role="tablist">
                <li class="nav-item mb-0" role="presentation">
                  <a class="nav-link border-0 active" href="javascript:void(0)" (click)="onMenuTab('1')"
                    [ngClass]="{'active': listTab}">List view</a>
                </li>
                <li class="nav-item mb-0" role="presentation">
                  <a class="nav-link border-0" href="javascript:void(0)" (click)="onMenuTab('2')"
                    [ngClass]="{'active': gridTab}">Grid
                    view</a>
                </li>
              </ul>

            </div>

          </div>

        </div>
      </div>
      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-4 py-2">
        <div class="container-fluid">

          <div class="tab-content">
            <div class="tab-pane fade show active" id="view-list" [ngClass]="{'show active': listTab}">
              <div class="row">
                <div class="col-12">
                  <div class="card mb-3">
                    <div class="table-responsive">
                      <table class="table vertical-center table-hover no-wrap mb-0">
                        <thead>
                          <tr>
                            <th scope="col" class="border-0 text-muted text-uppercase ps-4">#</th>
                            <th scope="col" class="border-0 text-muted text-uppercase">Name</th>
                            <th scope="col" class="border-0 text-muted text-uppercase">Address</th>
                            <th scope="col" class="border-0 text-muted text-uppercase">Email</th>
                            <th scope="col" class="border-0 text-muted text-uppercase">Manage</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="ps-4">1</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar1.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Daniel Kristeen</h6>
                                  <small class="text-truncate text-muted">UI Designer</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">523 Williams St, Kingsville,</span><br>
                              <small class="text-muted">TX, 78363</small>
                            </td>
                            <td>
                              <span class="text-muted">daniel@website.com</span><br>
                              <span class="text-muted">999 - 444 - 555</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2016</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="ps-4">2</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar2.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Amelia Green</h6>
                                  <small class="text-truncate text-muted">Account</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">392 W Clark St, East Palestine</span><br>
                              <small class="text-muted">OH, 44413</small>
                            </td>
                            <td>
                              <span class="text-muted">Amelia@website.com</span><br>
                              <span class="text-muted">999 - 444 - 256</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2018</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="ps-4">3</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar3.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Charlotte Green</h6>
                                  <small class="text-truncate text-muted">Java developer</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">3015 Carl Sutton Rd, Lizella,</span><br>
                              <small class="text-muted">GA, 31052</small>
                            </td>
                            <td>
                              <span class="text-muted">Charlotte@website.com</span><br>
                              <span class="text-muted">999 - 444 - 486</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2019</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="ps-4">4</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar4.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Susie Willis</h6>
                                  <small class="text-truncate text-muted">UI Designer</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">10609 Otsego Pike, Rudolph,</span><br>
                              <small class="text-muted">OH, 78363</small>
                            </td>
                            <td>
                              <span class="text-muted">Susie@website.com</span><br>
                              <span class="text-muted">999 - 444 - 159</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2019</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="ps-4">5</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar5.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Marshall Nichols</h6>
                                  <small class="text-truncate text-muted">UI Designer</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">12593 Alleghany Rd, Silver Creek,</span><br>
                              <small class="text-muted">NY, 78363</small>
                            </td>
                            <td>
                              <span class="text-muted">Marshall@website.com</span><br>
                              <span class="text-muted">999 - 444 - 369</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2020</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="ps-4">6</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar6.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Daniel Kristeen</h6>
                                  <small class="text-truncate text-muted">Marketing</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">1994 W Ludington Dr, Farwell,</span><br>
                              <small class="text-muted">TX, 78363</small>
                            </td>
                            <td>
                              <span class="text-muted">daniel@website.com</span><br>
                              <span class="text-muted">999 - 444 - 751</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2020</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="ps-4">7</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar7.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Jason Porter</h6>
                                  <small class="text-truncate text-muted">Sales</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">523 Williams St, Kingsville,</span><br>
                              <small class="text-muted">TX, 78363</small>
                            </td>
                            <td>
                              <span class="text-muted">Jason@website.com</span><br>
                              <span class="text-muted">999 - 444 - 555</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2019</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="ps-4">8</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar8.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Darryl Day</h6>
                                  <small class="text-truncate text-muted">React Devloper</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">4870 County 14 Hwy, Perham,</span><br>
                              <small class="text-muted">TX, 78363</small>
                            </td>
                            <td>
                              <span class="text-muted">Darryl@website.com</span><br>
                              <span class="text-muted">999 - 444 - 252</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2017</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="ps-4">9</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar9.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Jane Hunt</h6>
                                  <small class="text-truncate text-muted">UI Designer</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">1994 W Ludington Dr, Farwell,</span><br>
                              <small class="text-muted">TX, 78363</small>
                            </td>
                            <td>
                              <span class="text-muted">Jane@website.com</span><br>
                              <span class="text-muted">999 - 444 - 888</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2018</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="ps-4">10</td>
                            <td>
                              <div class="media">
                                <div class="avatar me-3">
                                  <img class="avatar rounded-circle" src="assets/images/xs/avatar10.jpg" alt="avatar">
                                </div>
                                <div class="media-body overflow-hidden">
                                  <h6 class="text-truncate mb-0 me-auto">Daniel Kristeen</h6>
                                  <small class="text-truncate text-muted">UI Designer</small>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span class="text-muted">523 Williams St, Kingsville,</span><br>
                              <small class="text-muted">TX, 78363</small>
                            </td>
                            <td>
                              <span class="text-muted">daniel@website.com</span><br>
                              <span class="text-muted">999 - 444 - 555</span>
                            </td>
                            <td>
                              <span class="text-muted">15 Mar 2020</span><br>
                              <small class="text-muted">10: 55 AM</small>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-default"><i class="zmdi zmdi-zoom-in"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-edit"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-default ml-1"><i class="zmdi zmdi-delete"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <nav>
                    <ul class="pagination pagination-custom">
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">Previous</a></li>
                      <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">Next</a></li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="view-grid" [ngClass]="{'show active': gridTab}">
              <div class="row g-2">
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="card text-center pt-3">
                    <div class="card-body">
                      <div class="card-user-avatar">
                        <img src="assets/images/sm/avatar1.jpg" alt="avatar">
                      </div>
                      <div class="card-user-detail mt-4">
                        <h5>Michelle Green</h5>
                        <span class="text-muted">michelle.green@gmail.com</span>
                        <p>+14 123 456 789 - New york (USA)</p>
                        <div class="social">
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Facebook"><i class="zmdi zmdi-facebook-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Linkedin"><i class="zmdi zmdi-linkedin-box"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="card text-center pt-3">
                    <div class="card-body">
                      <div class="card-user-avatar">
                        <img src="assets/images/sm/avatar2.jpg" alt="avatar">
                      </div>
                      <div class="card-user-detail mt-4">
                        <h5>Charlotte Green</h5>
                        <span class="text-muted">michelle.green@gmail.com</span>
                        <p>+14 123 456 789 - New york (USA)</p>
                        <div class="social">
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Facebook"><i class="zmdi zmdi-facebook-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Github"><i class="zmdi zmdi-github-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Linkedin"><i class="zmdi zmdi-linkedin-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Instagram"><i class="zmdi zmdi-instagram"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="card text-center pt-3">
                    <div class="card-body">
                      <div class="card-user-avatar">
                        <img src="assets/images/sm/avatar3.jpg" alt="avatar">
                      </div>
                      <div class="card-user-detail mt-4">
                        <h5>Susie Willis</h5>
                        <span class="text-muted">michelle.green@gmail.com</span>
                        <p>+14 123 456 789 - New york (USA)</p>
                        <div class="social">
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Facebook"><i class="zmdi zmdi-facebook-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Github"><i class="zmdi zmdi-github-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Instagram"><i class="zmdi zmdi-instagram"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="card text-center pt-3">
                    <div class="card-body">
                      <div class="card-user-avatar">
                        <img src="assets/images/sm/avatar4.jpg" alt="avatar">
                      </div>
                      <div class="card-user-detail mt-4">
                        <h5>Daniel Kristeen</h5>
                        <span class="text-muted">michelle.green@gmail.com</span>
                        <p>+14 123 456 789 - New york (USA)</p>
                        <div class="social">
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Facebook"><i class="zmdi zmdi-facebook-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Github"><i class="zmdi zmdi-github-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Linkedin"><i class="zmdi zmdi-linkedin-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Instagram"><i class="zmdi zmdi-instagram"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="card text-center pt-3">
                    <div class="card-body">
                      <div class="card-user-avatar">
                        <img src="assets/images/sm/avatar5.jpg" alt="avatar">
                      </div>
                      <div class="card-user-detail mt-4">
                        <h5>Jason Porter</h5>
                        <span class="text-muted">michelle.green@gmail.com</span>
                        <p>+14 123 456 789 - New york (USA)</p>
                        <div class="social">
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Facebook"><i class="zmdi zmdi-facebook-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Linkedin"><i class="zmdi zmdi-linkedin-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Instagram"><i class="zmdi zmdi-instagram"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="card text-center pt-3">
                    <div class="card-body">
                      <div class="card-user-avatar">
                        <img src="assets/images/sm/avatar6.jpg" alt="avatar">
                      </div>
                      <div class="card-user-detail mt-4">
                        <h5>Darryl Day</h5>
                        <span class="text-muted">michelle.green@gmail.com</span>
                        <p>+14 123 456 789 - New york (USA)</p>
                        <div class="social">
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Facebook"><i class="zmdi zmdi-facebook-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Github"><i class="zmdi zmdi-github-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Linkedin"><i class="zmdi zmdi-linkedin-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Instagram"><i class="zmdi zmdi-instagram"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="card text-center pt-3">
                    <div class="card-body">
                      <div class="card-user-avatar">
                        <img src="assets/images/sm/avatar7.jpg" alt="avatar">
                      </div>
                      <div class="card-user-detail mt-4">
                        <h5>Daniel Kristeen</h5>
                        <span class="text-muted">michelle.green@gmail.com</span>
                        <p>+14 123 456 789 - New york (USA)</p>
                        <div class="social">
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Linkedin"><i class="zmdi zmdi-linkedin-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Instagram"><i class="zmdi zmdi-instagram"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div class="card text-center pt-3">
                    <div class="card-body">
                      <div class="card-user-avatar">
                        <img src="assets/images/sm/avatar8.jpg" alt="avatar">
                      </div>
                      <div class="card-user-detail mt-4">
                        <h5>Amelia Green</h5>
                        <span class="text-muted">michelle.green@gmail.com</span>
                        <p>+14 123 456 789 - New york (USA)</p>
                        <div class="social">
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Facebook"><i class="zmdi zmdi-facebook-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Github"><i class="zmdi zmdi-github-box"></i></a>
                          <a class="icon p-2" href="javascript:void(0)" data-bs-toggle="tooltip" title=""
                            data-original-title="Linkedin"><i class="zmdi zmdi-linkedin-box"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
